module.exports = __webpack_public_path__ + "videos/dangerous.b80dea7.mp4";